import React, {Component} from 'react'
import {InputNumber} from 'antd'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'

class NumberColumn extends Component {
  render() {
    const {record, column, value, onChange, dataIndex} = this.props
    return record.editable ? (
      <InputNumber
        {...this.props}
        value={value}
        style={{width: '100%'}}
        onChange={value => onChange(value, record[dataIndex], column)}
      />
    ) : (
      <MoneyCell value={value} />
    )
  }
}

NumberColumn.propTypes = {}
NumberColumn.defaultProps = {dataIndex: 'key'}

export default NumberColumn
